/**
 * Returns a function, that, as long as it continues to be invoked, will not
 * be triggered. The function will be called after it stops being called for
 * N milliseconds. If `immediate` is passed, trigger the function on the
 * leading edge, instead of the trailing.
 *
 * @param {Function} func to be executed on debounce
 * @param {number} wait time in milliseconds
 * @param {boolean} immediate boolean
 *
 * */
export function debounce(func, wait, immediate) {
  let timeout;
  return function() {
    let context = this, args = arguments;
    let later = function() {
      timeout = null;
      if (!immediate) func.apply(context, args);
    };
    let callNow = immediate && !timeout;
    clearTimeout(timeout);
    timeout = setTimeout(later, wait);
    if (callNow) func.apply(context, args);
  };
}

/**
 * Shuffles array in place. ES6 version
 * @param {Array} a items An array containing the items.
 */
export function shuffle(a) {
  for (let i = a.length - 1; i > 0; i--) {
    const j = Math.floor(Math.random() * (i + 1));
    [a[i], a[j]] = [a[j], a[i]];
  }
  return a;
}

/**
 * Returns a random integer between min (inclusive) and max (inclusive).
 * The value is no lower than min (or the next integer greater than min
 * if min isn't an integer) and no greater than max (or the next integer
 * lower than max if max isn't an integer).
 * Using Math.round() will give you a non-uniform distribution!
 */
export function getRandomInt(min, max) {
  min = Math.ceil(min);
  max = Math.floor(max);
  return Math.floor(Math.random() * (max - min + 1)) + min;
}

export function qsArray ( selector, node ) {
  node = node || document;
  let nodeList = node.querySelectorAll(selector);
  let array = [];
  for(let i = 0; i < nodeList.length; i++) {
    array.push(nodeList[i]);
  }
  return array;
}

export function numberMap (input, inputStart, inputStop, outputStart, outputStop) {
  return outputStart + (outputStop - outputStart) * ((input - inputStart) / (inputStop - inputStart))
}


export function getQueryStringVariable(variable)
{
  var query = window.location.search.substring(1);
  var vars = query.split("&");
  for (var i=0;i<vars.length;i++) {
    var pair = vars[i].split("=");
    if(pair[0] == variable){return pair[1];}
  }
  return(false);
}

export function getFullWidth() {
  return window.innerWidth;
  // return Math.max(document.documentElement.clientWidth, window.innerWidth || 0);
}
export function getFullHeight() {
  return window.innerHeight;
  // return Math.max(document.documentElement.clientHeight, window.innerHeight || 0);
}

export function getVW(percent) {
  let vw = (percent/100) * getFullWidth()
  return vw;
}
export function getVH(percent) {
  let vh = (percent/100) * getFullHeight();
  return vh;
}

export function getScrollTop() {
  return document.documentElement.scrollTop || document.body.scrollTop;
}

export function getElementHeight(selector) {
  let height = 0;
  const elem = document.querySelector(selector);
  if(elem) {
    const rect = elem.getBoundingClientRect();
    height = rect.height;
  }
  return height;
}
